<template>
  <div>
    <div class="column-acoes">
      <el-dropdown trigger="click" :disabled="this.desabilitaAbrirAcoes">
        <span :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}`" class="el-dropdown-link" :class="{ 'is-disabled': this.desabilitaAbrirAcoes }">Ações <i class="el-icon-more"></i></span>
        <el-dropdown-menu slot="dropdown" class="acoes-dropdown">
          <el-dropdown-item v-for="(acao, index) in columnAcoes" :key="index">
            <el-button v-show="('show' in acao)? acao.show : true" type="text" @click="acao.func(row)">{{acao.label}}</el-button>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="text"></el-button>
    </div>
    <ModalEnvio
      :open.sync="mostraEnvio"
      title="Selecionar Envio"
      width="523px"
      @close="mostraEnvio = false"
      :close-on-click-modal="true"
      :destroy-on-close="true"
      :payloadWidget="() => {return carregaPayload}"
    >
    </ModalEnvio>
  </div>
</template>
<style scoped>
.grid-content {
  min-height: 36px;
}
.is-disabled {
  color: #bbb !important;
  pointer-events: none !important;
}
.column-acoes {
  text-align: right;
  margin: 18px 0 0;
  font-weight: bold;
  text-transform: uppercase;
}
.el-dropdown {
  font-size:12px !important;
}
</style>
<script>
import { mapGetters, mapState } from 'vuex'
import { EnumCanalAtendimentoOrigem } from '@/constants/EnumCanalAtendimentoOrigem'
import ModalEnvio from '@/components/ModalEnvio/ModalEnvio'
import ArrowButton from '@/components/listagemColumn/ArrowButton'
import { preloadWidgetDefault } from '@/components/TemplateSolicitacao/componentes/PreLoadWidget'

export default {
  name: 'AcoesWidget',
  props: {
    column: {
      type: String
    },
    row: {
      type: Object
    },
    preloadWidget: {
      type: Function
    }
  },
  components: { ModalEnvio },
  data () {
    return {
      mostraEnvio: false,
      payloadWidget: {}
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['aplicacao', 'estilo', 'canalAtendimentoOrigem']),
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade', 'frameId', 'embedJson']),
    columnAcoes () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return this.menuMosiaDesk
        default:
          return { field: '', component: ArrowButton, acao: this.clickDetalhe }
      }
    },
    carregaPayload () {
      if (!this.preloadWidget) {
        return this.carregaPayloadWidget()
      }
      return this.preloadWidget()
    },
    menuMosiaDesk () {
      const payloadMenu = []
      if (
        this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioChatWidget ||
        this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioEmailWidget ||
        this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioWhatsappWidget
      ) {
        payloadMenu.push({ label: 'Enviar', func: this.abreDialogEnvio })
      }
      if (this.funcionalidade.parametros.configuracoesDeWidgets.exibeDetalheWidget) {
        payloadMenu.push({ label: 'Detalhes', func: this.clickDetalhe })
      }
      return payloadMenu
    },
    desabilitaEnviar () {
      return !(this.opcaoEnvio !== '' && (this.escolhasEnvio.length > 0))
    },
    desabilitaAbrirAcoes () {
      return (!this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioChatWidget && !this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioEmailWidget && !this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioWhatsappWidget)
    }
  },
  methods: {
    clickDetalhe (row) {
      switch (this.funcionalidade.idFuncionalidade) {
        case '10':
          return this.$router.push({
            path: `/${this.funcionalidade.idFuncionalidade}/detalhe`,
            query: {
              idOcorrencia: row['idReembolso'],
              idGuia: row['numeroGuiaReembolso']
            }
          })
        case '31':
          if (row['guia']) {
            return this.$router.push({
              path: `/${this.funcionalidade.idFuncionalidade}/detalhe`,
              query: {
                idAutorizacao: row['guia']['idAutorizacao']
              }
            })
          } else {
            return this.$router.push({
              path: `/${this.funcionalidade.idFuncionalidade}/detalhe`,
              query: {
                idOcorrencia: row['id_ocorrencia']
              }
            })
          }
        default:
          return this.$router.push({
            path: `/${this.funcionalidade.idFuncionalidade}/detalhe`,
            query: {
              idOcorrencia: row['id_ocorrencia']
            }
          })
      }
    },
    async abreDialogEnvio () {
      this.mostraEnvio = true
    },
    carregaPayloadWidget () {
      return preloadWidgetDefault(
        this.row,
        this.funcionalidade,
        this.embedJson.atendimento.tokenAtendente,
        this.aplicacao
      )
    }
  }
}
</script>
